import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

    }

    init() {

        // Wait the split
        this.delay = gsap.delayedCall(1, () => {
            this.$chars = this.el.querySelectorAll('.char-wrap>span');
            
            this.$chars.forEach(char => {
                char.addEventListener('mouseenter',this.mouseenter);
                char.addEventListener('animationend',this.animationend);

            });
        })
    }

    mouseenter(e) {
        e.currentTarget.classList.add('is-hover');

    }
    animationend(e) {
        e.currentTarget.classList.remove('is-hover');
    }

    destroy() {
        if(this.delay != undefined) {
            this.delay.kill();
        }

        if(this.$chars.length > 0) {
            this.$chars.forEach(char => {
                char.addEventListener('mouseenter',this.mouseenter);
                char.addEventListener('animationend',this.animationend);
            });
        }
    }
}
